import { useQuery } from "@tanstack/react-query";
import { FinanceKeys } from "web_myplann/Api/Finances/financeKeys";
import { getClientFinancialPlanIncomesV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useIncomeQuery = () => {
	return useQuery({
		queryKey: FinanceKeys.income(),
		queryFn: processResponse(() => getClientFinancialPlanIncomesV2()),
	});
};
